<div class="as-card-explanation primary-color" *ngIf="explanation">
  <span>{{ explanation }}</span>
</div>

<div class="as-card-wrapper" #asCardWrapper [class.active]="isActive" [class.disabled]="disabled"
  [class.center-label]="centerLabel">
  <div class="as-card-label" *ngIf="label">
    <span #asCardLabelText>{{ label }}</span>
  </div>
  <div class="as-card-outline" *ngIf="showOutline">
    <div class="as-card-outline-start"></div>
    <div class="as-card-outline-gap" #asCardOutlineGap></div>
    <div class="as-card-outline-end"></div>
  </div>
  <div class="as-card-outline as-card-outline-thick" *ngIf="showOutline">
    <div class="as-card-outline-start"></div>
    <div class="as-card-outline-gap" #asCardOutlineGap></div>
    <div class="as-card-outline-end"></div>
  </div>
  <div class="as-card-content">
    <ng-content></ng-content>
  </div>
</div>
